import { Component } from '@angular/core';
import { MyharrellsService } from '../myharrells.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { Dotcom2024Service } from '../dotcom2024.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CustomPromisifyLegacy } from 'util';
import { MyharrellsloginpromptComponent } from "../myharrellsloginprompt/myharrellsloginprompt.component";

export interface course {
  SearchKey?: any
  ItemId?: number
  ItemAlias?: string
  Title: string
  Content?: string
  Summary: string
  PublishDate: string
  VisibilityId?: number
  Notes?: any
  PostAuthorExternalId?: number
  FirstName?: string
  LastName?: string
  EmployeeId?: number
  EmployeeBio?: string
  UserIsAuthenticated?: boolean
  Category?: any
  ResourceURL: string
  ImageName?: string
  NumberOfCEUs?: number
  CertId?: number
  CertName?: any
  CertSubTypeId?: number
  CertSubTypeName?: any
  CategoryId?: number
  CategoryName?: any
  TypeId?: number
  TypeName?: string
  MarketName?: any
  StateId?: any
  StateName?: any
  Id: number
  Comment?: any
  IsMatrixPost: boolean,
  isMatrixPublicCourse?: boolean
  RevisionAuthor?: string
  Tags?: string[]
}


@Component({
    selector: 'app-education',
    standalone: true,
    templateUrl: './education.component.html',
    styleUrl: './education.component.css',
    imports: [CommonModule, FormsModule, MyharrellsloginpromptComponent]
})
export class EducationComponent {

  myHarrellsLoginEmail: string;
  courseAlias: string
  educationSearchKey: string = '';
  disableMoreButton: boolean = false;
  displayAllcourses: boolean = false;

  showFilterObjects: boolean = false;
  topicsExpanded: boolean = true;
  selectedState: string = '';
  selectedCategory: string = '';
  allStates: any[] = [];
  allCategories: any[] = [];


  courseList: course[] = [];
  courseListFiltered: course[] = [];

  // CEUTypes: string[] = ['CEU', 'Core', 'Pesticide', 'GCSAA', 'FNGLA'];

  CEUTypes: string[] = ['CEU', 'GCSAA', 'CCA' ,'FNGLA'];



  loggedInToMyHarrells: boolean = false;

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Education/";
  blogImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Blog-Photos/";
  educationImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Education/";

  constructor(public myHarrellsService: MyharrellsService, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public router: Router) { }

  ngOnInit() {

    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('loggedInMyHarrellsUser')) {
      let loggedInUser = JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser'));
      if (loggedInUser != null) {
        this.loggedInToMyHarrells = true;
      }
      else {
        this.loggedInToMyHarrells = false;
      }
    }

    //get all matrix courses
    this.GetAllCourses();
  }

  GetAllCourses() {
    this.courseListFiltered = [];
    this.GetMatrixLMSCourses().then(matrixCourses => {
      //get non matrix courses 
      this.GetEducationPostsNonMatrix().then(publicCourses => {
        //combine the two lists into the courseList
        this.courseList = this.myHarrellsService.publicCourseList;
        for (let i = 0; i < this.myHarrellsService.matrixCourseList.length; i++) {
          //using the public course list model as it has more properties that we need
          var element = this.myHarrellsService.matrixCourseList[i];

          this.courseList.push({
            IsMatrixPost: true,
            Title: element.name,
            Summary: (element.short_description != "") ? element.short_description : element.long_description,
            ResourceURL: element.url,
            ImageName: element.ImageName,
            PublishDate: element.start_at,
            Id: element.id,
            TypeName: "Course",
            RevisionAuthor: 'Harrells',
            Tags: element.tags,
            isMatrixPublicCourse: element.isMatrixPublicCourse,

          });

          if (i == this.myHarrellsService.matrixCourseList.length - 1) {
            for (let j = 0; j < this.courseList.length; j++) {
              if (this.courseList[j].IsMatrixPost) {

                //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
                this.dotComService.checkIfImageExists(this.educationImagePaths + this.courseList[j].Title + ".jpg", (exists) => {
                  if (exists) {
                    // Success code
                    this.courseList[j].ImageName = this.educationImagePaths + this.courseList[j].Title + ".jpg"
                  } else {
                    // Fail code
                    //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png"
                    this.dotComService.checkIfImageExists(this.educationImagePaths + this.courseList[j].Title + ".png", (exists) => {
                      if (exists) {
                        // Success code
                        this.courseList[j].ImageName = this.educationImagePaths + this.courseList[j].Title + ".png"
                      } else {
                        // Fail code - use default
                        this.courseList[j].ImageName = this.baseImagePaths + "harrellsh.png"
                      }
                    })
                  }
                });

                if (j < 10) {
                  this.courseListFiltered.push(this.courseList[j]);
                }
              }
              else {
                //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
                this.dotComService.checkIfImageExists(this.blogImagePaths + this.courseList[j].ItemAlias + ".jpg", (exists) => {
                  if (exists) {
                    // Success code
                    this.courseList[j].ImageName = this.blogImagePaths + this.courseList[j].ItemAlias + ".jpg"
                  } else {
                    // Fail code
                    //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png"
                    this.dotComService.checkIfImageExists(this.blogImagePaths + this.courseList[j].ItemAlias + ".png", (exists) => {
                      if (exists) {
                        // Success code
                        this.courseList[j].ImageName = this.blogImagePaths + this.courseList[j].ItemAlias + ".png"
                      } else {
                        // Fail code - use default
                        this.courseList[j].ImageName = this.baseImagePaths + "harrellsh.png"
                      }
                    })
                  }
                });

                if (j < 10) {
                  this.courseListFiltered.push(this.courseList[j]);
                }
              }
            }
          }

          if (i == this.myHarrellsService.matrixCourseList.length - 1) {
            this.courseListFiltered.sort((a, b) => (a.PublishDate > b.PublishDate) ? -1 : 1);
          }

        }
      })
    })
  }

  GetMatrixLMSCourses() {
    return new Promise((resolve, reject) => {
      this.myHarrellsService.GetMatrixLMSCourses().subscribe((data: any) => {
        //this returns them all (myharrells, marketing, compliance, etc)
        //we will filter them down to just the education ones - brandon/allison marking the field course code with the word 'myHarrells'
        this.myHarrellsService.matrixCourseList = data.filter(x => x.course_code != null);
        this.myHarrellsService.matrixCourseList = this.myHarrellsService.matrixCourseList.filter(x => x.course_code.toLowerCase().includes('myharrells'));
        //sourt by course name
        this.myHarrellsService.matrixCourseList.sort((a, b) => (a.name > b.name) ? 1 : -1);

        //build the states and courses dropdowns from dynamic data
        this.allCategories = [];
        this.allStates = [];
        for (let index = 0; index < this.myHarrellsService.matrixCourseList.length; index++) {
          const element = this.myHarrellsService.matrixCourseList[index];
          console.log(element.tags);
          element.isMatrixPublicCourse = false;
          if (element.tags.length > 0) {

            for (let i = 0; i < element.tags.length; i++) {
              const tag = element.tags[i];
              if (tag.substring(0, 4) == 'ceu-') {
                //check to see if the tag is already in the list
                if (this.allStates.findIndex(x => x == tag.substring(4)) == -1) {
                  this.allStates.push(tag.substring(4));
                }
              }
              else {
                if (tag.substring(0, 4) == 'cat-') {
                  //check to see if the tag is already in the list
                  if (this.allCategories.findIndex(x => x == tag) == -1) {
                    //make sure its not in the array CEUTypes - these have their own checkbox
                    if (this.allCategories.findIndex(x => x == tag.substring(4)) == -1) {
                      this.allCategories.push(tag.substring(4));
                    }
                  }
                }
              }
              if (tag == 'public') {
                element.isMatrixPublicCourse = true;
              }

            }
          }


          if (index == this.myHarrellsService.matrixCourseList.length - 1) {
            //sort order
            this.allStates.sort((a, b) => (a > b) ? 1 : -1);
            this.allCategories.sort((a, b) => (a > b) ? 1 : -1);
            resolve('');
          }
        }

      });

    });
  }

  // LogUserIntoMatrixAndGoToCourse() {

  //   //this will be under myharrells login so we will use the logged in users email address and our 
  //   //one size fits all password to log them into matrix 
  //   //if they do not have an account in matrix this will create one for them and make them a user
  //   //if they aren't enrolled in this course it will enroll them in it 
  //   //then it will redirect them to the matrix home page

  //   this.myHarrellsLoginEmail = 'accounting@canoaranchgolfclub.com'; //'allisahm@gmail.com'; //'mwisler@harrells.com';
  //   this.courseAlias = 'fusarium'; //'fairyringmanagement'

  //   this.myHarrellsService.ValidateUserInMatrixLMSSystemAsync(this.myHarrellsLoginEmail, this.courseAlias).subscribe((data: any) => {

  //     //should be in the matrix system now and enrolled in the course
  //     //take them to the matrix

  //     (document.getElementById("userid") as HTMLInputElement).value = 'accounting@canoaranchgolfclub.com';// 'allisahm@gmail.com'; // 'mwisler@harrells.com';
  //     (document.getElementById("password") as HTMLInputElement).value = '7!k8CoWf$3';
  //     (document.getElementById("submitButton") as HTMLButtonElement).click();

  //   });


  // }

  SearchEducationFired() {
    //user filtered the search 
    //this.courseList = [];
    this.disableMoreButton = true

    this.courseListFiltered = [];

    let gcsaa: any[] = [];
    let cca: any[] = [];
    let fngla: any[] = [];
    let ceu: any[] = [];
    let category: any[] = [];
    let spanish: any[] = [];

    //check if checkbox with id spanish is checked 
    if (document.getElementById("Spanish") as HTMLInputElement) {
      if ((document.getElementById("Spanish") as HTMLInputElement).checked) {
        spanish = this.myHarrellsService.publicCourseList.filter(course =>
          course.Tags && Array.isArray(course.Tags) && course.Tags.includes('spanish')
        );
      }
    }

    //check if checkbox with id gcsaa is checked 
    if (document.getElementById("GCSAA") as HTMLInputElement) {
      if ((document.getElementById("GCSAA") as HTMLInputElement).checked) {
        gcsaa = this.myHarrellsService.publicCourseList.filter(course =>
          course.Tags && Array.isArray(course.Tags) && course.Tags.includes('gcsaa')
        );
      }
    }

        //check if checkbox with id cca is checked 
    if (document.getElementById("CCA") as HTMLInputElement) {
      if ((document.getElementById("CCA") as HTMLInputElement).checked) {
        cca = this.myHarrellsService.publicCourseList.filter(course =>
          course.Tags && Array.isArray(course.Tags) && course.Tags.includes('cca')
        );
      }
    }

    if (document.getElementById("CEU") as HTMLInputElement) {
      if ((document.getElementById("CEU") as HTMLInputElement).checked) {
        for (let index = 0; index < this.myHarrellsService.publicCourseList.length; index++) {
          const element = this.myHarrellsService.publicCourseList[index];
          const elementsTags = this.myHarrellsService.publicCourseList[index].Tags;
          if (element.Tags) {
            //check to see if this course has at least one ceu tag
            if (element.Tags.some(x => x.includes('ceu-'))) {
              if (this.selectedState != '') {
                //filter by state selected in the dropdown
                var state = 'ceu-' + this.selectedState.toLowerCase();
                if (element.Tags.some(y => y.indexOf(state) > -1)) {
                  ceu.push(element)
                }
              }
              else {
                ceu.push(element)
              }
            }
          }
        }
      }
    }

    if (document.getElementById("FNGLA") as HTMLInputElement) {
      if ((document.getElementById("FNGLA") as HTMLInputElement).checked) {
        fngla = this.myHarrellsService.publicCourseList.filter(course =>
          course.Tags && Array.isArray(course.Tags) && course.Tags.includes('fngla')
        );
      }
    }

    if (this.selectedCategory != '') {
      for (let index = 0; index < this.myHarrellsService.publicCourseList.length; index++) {
        const element = this.myHarrellsService.publicCourseList[index];
        //filter by state selected in the dropdown
        var cat = this.selectedCategory.toLowerCase();
        if (element.Tags && element.Tags.some(y => y.indexOf(cat) > -1)) {
          category.push(element)
        }
      }
    }



    if (spanish.length > 0 || gcsaa.length > 0 || ceu.length > 0 || fngla.length > 0 || cca.length > 0 || category.length > 0) {
      for (let i = 0; i < spanish.length; i++) {
        //dont add if already in the list
        if (this.courseListFiltered.findIndex(x => x.Title == spanish[i].Title) == -1)
          this.courseListFiltered.push(spanish[i]);
      }
      for (let i = 0; i < gcsaa.length; i++) {
        //dont add if already in the list
        if (this.courseListFiltered.findIndex(x => x.Title == gcsaa[i].Title) == -1)
          this.courseListFiltered.push(gcsaa[i]);
      }
      for (let i = 0; i < cca.length; i++) {
        //dont add if already in the list
        if (this.courseListFiltered.findIndex(x => x.Title == cca[i].Title) == -1)
          this.courseListFiltered.push(cca[i]);
      }      
      for (let i = 0; i < ceu.length; i++) {
        if (this.courseListFiltered.findIndex(x => x.Title == ceu[i].Title) == -1)
          this.courseListFiltered.push(ceu[i]);
      }
      for (let i = 0; i < fngla.length; i++) {
        if (this.courseListFiltered.findIndex(x => x.Title == fngla[i].Title) == -1)
          this.courseListFiltered.push(fngla[i]);
      }
      for (let i = 0; i < category.length; i++) {
        if (this.courseListFiltered.findIndex(x => x.Title == category[i].Title) == -1)
          this.courseListFiltered.push(category[i]);
      }


    }
    else {
      this.courseListFiltered = this.courseList; //use the full list
    }

    if (this.educationSearchKey.length > 0) {
      this.courseListFiltered = this.courseListFiltered.filter(x => x.Title.toLowerCase().includes(this.educationSearchKey.toLowerCase()));
    }

    this.courseListFiltered.sort((a, b) => (a.PublishDate > b.PublishDate) ? -1 : 1);




  }

  DisplayAllEducationPosts() {

    this.educationSearchKey = '';
    (document.getElementById("CEU") as HTMLInputElement).checked = false;
    (document.getElementById("GCSAA") as HTMLInputElement).checked = false;
    (document.getElementById("CCA") as HTMLInputElement).checked = false;
    (document.getElementById("FNGLA") as HTMLInputElement).checked = false;


    this.courseListFiltered = this.courseList;
    this.courseListFiltered.sort((a, b) => (a.PublishDate > b.PublishDate) ? -1 : 1);

  }

  GoToEducationCourse(courseSelected: course) {
    this.myHarrellsService.selectedCourse = courseSelected;
    this.myHarrellsService.courseIdToUse = courseSelected.Id;
    if (courseSelected.IsMatrixPost) {
      if (!this.loggedInToMyHarrells && !courseSelected.isMatrixPublicCourse) {
        this.OpenLoginModal(courseSelected);
        return;
      }
      else if (!this.loggedInToMyHarrells && courseSelected.isMatrixPublicCourse) {
        //they dont need to log in to view this matrix course as it has the "public" tag on it in the matrix system

        //go to the matrix platform to display the course - not using legacy education post for this one 
        this.myHarrellsService.courseAliasSelected = ""; //courseSelected.ItemAlias;
        this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = courseSelected.Id;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl('/matrix');
        });


      }
      else {
        //go to the matrix platform to display the course - not using legacy education post for this one 
        this.myHarrellsService.courseAliasSelected = ""; //courseSelected.ItemAlias;
        this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = courseSelected.Id;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl('/matrix');
        });
        //the ebove opens a new tab, so we need to return this existing tab to education
        // setTimeout(() => {
        //   window.location.href = '/education';
        // }, 3000);
        //window.location.href = '/education'; //this caused a reload - issue here 
      }
    } else {
      //go to the course in our home grown education platform
      //window.open('/post?id=' + courseSelected.ItemAlias, '_blank');
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl('/post?id=' + courseSelected.ItemAlias);
      });
    }
  }

  GetEducationPostsNonMatrix() {
    return new Promise((resolve, reject) => {
      this.myHarrellsService.GetEducationPostsNonMatrix().subscribe((data: any) => {
        this.myHarrellsService.publicCourseList = data.filter(x => x.IsMatrixPost == false); //exclude the matrix courses from this list
        resolve('')
      })
    });
  }

  OpenLoginModal(course: course) {
    this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = course.Id;
    document.getElementById("loginModal").style.display = "block";
  }

  CancelLoginModal() {
    this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = 0;
    this.CloseLoginModal();
  }

  EnrollForMyHarrells() {
    this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = 0;
    this.router.navigate(['/myharrellsaccountsetup']);
  }

  CloseLoginModal() {
    document.getElementById("loginModal").style.display = "none";
  }

  LoginB4Course() {
    //the desired course to view is alread in this variable from when the login modal opened
    // this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = courseSelected.ItemAlias;


    //the login screen will check for this variable and if found will forward the user to this course after login
    this.router.navigateByUrl('/myharrellslogin');
  }

  GetNextGroupOfEducationPosts() {
    let topRange = this.courseListFiltered.length + 10;
    for (let i = this.courseListFiltered.length; i < topRange; i++) {
      for (let index = 0; index < this.courseList.length; index++) {
        const element = this.courseList[index];
        if (index == i) {
          this.courseListFiltered.push(element);
        }


      }


    }

  }

  ToggleExpand(groupToExpand: string) {
    if (groupToExpand == "Topics") {
      this.topicsExpanded = !this.topicsExpanded;

      if (this.topicsExpanded == false) {
        //group just collapsed and the checkboxes were set to unchecked
        //reload the grid
        // this.hasFilters = false;
        // this.dotComService.blogCategoriesSelected = "";
        // this.dotComService.blogPagingStart = 0;
        // this.GetMasterListOfPosts();
      }
    }
  }

  ToggleFilter() {
    this.showFilterObjects = !this.showFilterObjects;
  }

  EducationTypeCheckboxChanged(row: any, e: Event): void {
    this.SearchEducationFired();
  }

  StateChanged(e: any) {
    //if a state is selected then the ceu checkbox must be checked
    (document.getElementById("CEU") as HTMLInputElement).checked = true;

    this.SearchEducationFired();
  }

  CategoryChanged(e: any) {
    this.SearchEducationFired();
  }


}
